'use client';

import React from 'react';
import Image from 'next/image';

import { StarRating } from '@/widgets/StarRating';

import { calculateSatisfaction } from '@/utilities/calculateSatisfaction';

import { REVIEWS } from '@/constants/downloadApp';

import classes from '../../index.module.css';
import { useRevealGroup } from '../hooks';

const Reviews = () => {
    const groupRef = useRevealGroup<HTMLElement>(classes.revealVisible);

    return (
        <section ref={groupRef} className='bg-N50 px-4 py-16 md:py-24' aria-labelledby='download-app-reviews-title'>
            <div className='desktop-width md:px-8'>
                <div className='mb-12 grid items-center gap-8 md:grid-cols-[auto_1fr]'>
                    <div
                        data-reveal
                        className={`${classes.revealPop} ${classes.glassLight} mx-auto flex w-full max-w-xs flex-col items-center gap-3 rounded-lg p-8
                            text-center shadow-elevation1`}>
                        <span className='text-5xl font-black text-blackHighEmphasis'>۴.۶</span>
                        <StarRating rating={4.6} size='md' />
                        <span className={`rounded-lg px-3 py-1 text-[11px] font-bold ${calculateSatisfaction(4.6, 1).className}`}>
                            رضایت بالای کاربران از اپ
                        </span>
                    </div>

                    <div className='text-center md:text-right'>
                        <span
                            data-reveal
                            className={`${classes.reveal} mb-3 inline-block rounded-lg bg-primary/10 px-4 py-1.5 text-xs font-bold text-secondary`}>
                            نظرات کاربران اپلیکیشن
                        </span>
                        <h2
                            id='download-app-reviews-title'
                            data-reveal
                            className={`${classes.reveal} text-2xl font-black text-blackHighEmphasis md:text-4xl md:leading-[1.4]`}
                            style={{ '--reveal-delay': '80ms' } as React.CSSProperties}>
                            تجربه واقعی کاربران ازکی‌سرویس
                        </h2>
                        <p
                            data-reveal
                            className={`${classes.reveal} mt-4 text-sm leading-8 text-blackMediumEmphasis md:text-base`}
                            style={{ '--reveal-delay': '160ms' } as React.CSSProperties}>
                            از تعویض باتری اضطراری تا کارشناسی و استعلام خلافی؛ ببینید کاربران بعد از استفاده از اپ چه می‌گویند.
                        </p>
                    </div>
                </div>

                <ul className='m-0 grid list-none gap-4 p-0 sm:grid-cols-2 md:gap-6 lg:grid-cols-3'>
                    {REVIEWS.map((review, idx) => (
                        <li
                            key={review.id}
                            data-reveal
                            className={`${classes.revealPop} ${classes.featureCard} flex flex-col items-center gap-4 rounded-lg border border-N200
                            bg-white p-6 sm:items-stretch`}
                            style={{ '--reveal-delay': `${(idx % 3) * 90 + Math.floor(idx / 3) * 60}ms` } as React.CSSProperties}>
                            <div className='flex flex-col items-center gap-3 text-center sm:flex-row sm:text-right'>
                                <Image
                                    src={review.image}
                                    alt={`نظر ${review.name} درباره اپلیکیشن ازکی‌سرویس`}
                                    width={48}
                                    height={48}
                                    className='h-12 w-12 rounded-full bg-N100 object-cover'
                                />
                                <div className='flex flex-col items-center gap-1 sm:items-start'>
                                    <span className='text-sm font-black text-blackHighEmphasis'>{review.name}</span>
                                    <span className='text-[11px] text-blackLowEmphasis'>{review.vehicleModel}</span>
                                </div>
                                <span className='sm:mr-auto'>
                                    <StarRating rating={review.rate} size='sm' />
                                </span>
                            </div>
                            <blockquote className='text-center text-sm leading-7 text-blackMediumEmphasis sm:text-right'>
                                «{review.description}»
                            </blockquote>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default Reviews;
